import pubsub from "global/global";
import CustomEvent from "core/customEvent/index";

export default function FloatMessageBox({
  title,
  message,
  buttonType,
  hasCloseButton,
  hasTodayOffButton,
  handleYesClick
}) {
  const payload = {
    title: title,
    message: message,
    buttonType: buttonType || "OK",
    hasCloseButton: hasCloseButton || false,
    handleYesClick: handleYesClick || null,
    hasTodayOffButton: hasTodayOffButton || false,
    handleNoClick: null
  };

  pubsub.publish(CustomEvent.Messages.OPEN_MESSAGE_BOX, payload);
}
